export const DashboardSettingsBillingFeatureMapping = {

  // Updated plan features based on new pricing table
  StartPlan: [
    'Up to 2 Journeys',
    'Journey Modes (Pitch & Microsite)',
    'Basic Journey Insights',
    'Unlimited Content Blocks',
    'Content Library',
    'Synced Steps',
    'Email Notifications',
    'Comments',
    'Basic Access Permissions (Password Protection)',
    'Create with AI',
    'Customize Meta Title/Description',
    'Google Indexing Controls',
    'Custom Fonts',
    'Google Drive Integration',
    'User Roles (Coming Soon)',
    'Made in Journey Branding'
  ],
  GrowPlan: [
    'All features of Start included',
    'Unlimited Journeys',
    'All Access Permissions (Email Capture, Expiration Date, Custom Fields)',
    'User Roles (Coming Soon)',
    'No Made in Journey Branding',
    'Workspaces',
    'Tags and Filters',
    'Email Tracking (GET Parameter)',
    'AI Chatbot'
  ],
  ScalePlan: [
    'All features of Grow included',
    'Advanced Journey Insights',
    'Slack/Email Notifications',
    'Session Replay',
    'Customize NDA',
    'Organization Templates',
    'Clay Integration',
    'Zapier Integration',
    'Other Integrations'
  ],
  TeamsPlan: [
    'All features of Scale included',
    'Custom team pricing',
    'Dedicated account manager',
    'Custom integrations',
    'White-label solutions',
    'Advanced security features',
    'Custom training and onboarding',
    'SLA guarantees',
    '24/7 priority support'
  ],
};
